export class AssociateClaimToAudit {
    RawDataImport_ShardClaimIdentifier: number;
    Source: string;   // not claim source.
}
